import PerfectScroll from 'perfect-scrollbar';

export default {
	init() {
		setupBlocks();
	}
};

let filterDropdownAnimSpeed = 500;

function setupBlocks() {
	let $blocks = $('.vibe-teamtailor-job-archive-block').not('.initialized');

	if ($blocks.length > 0) {
		$blocks.each((index, item) => {
			setupBlock($(item));
		});
	}
}

function setupBlock($block) {
	setupBlockFilters($block);
	setupFiltering($block);
	setupCardFilterLinkClick($block);
	setupPagination($block);
	setupPopStateUpdate($block);

	$block.closest('.block').addClass('contains-vibe-job-archive-block');

	// Need to populate the state with the current state for the next state to update on back link click
	if (window.history.state === null) {
		window.history.replaceState({jobArchiveHtml : $block.get(0).innerHTML}, '', window.location.href);
	}

	$block.addClass('initialized');
}

function setupBlockFilters($block) {
	let $filtersDropdown = $block.find('.filter-options-wrapper');

	$filtersDropdown.each((index, item) => {
		let $filter = $(item),
			scrollWrapper = $filter.find('.filter-options').get(0),
			ps = new PerfectScroll(scrollWrapper, {
				suppressScrollX: true,
			});

		$(window).smartresize(() => {
			ps.update();
		});

		$filter.find('.filter-top-panel').on('click keyup', (e) => {
			if (e.keyCode !== undefined) {
				if (e.keyCode === 13) {
					toggleFilterDropdown($filter);
				}
			} else {
				e.preventDefault();
				toggleFilterDropdown($filter);
			}
		});
	});
}

function toggleFilterDropdown($filter) {
	if ($filter.hasClass('animating')) {
		return;
	}

	$filter.addClass('animating');

	if ($filter.hasClass('open')) {
		closeFilterPanel($filter);
	} else {
		openFilterOptions($filter);
	}

	setTimeout(() => {
		$filter.removeClass('animating');
	}, filterDropdownAnimSpeed);
}

function openFilterOptions($filter) {
	if ($filter.length > 0) {
		closeFilterPanel($('.filter-options-wrapper.open')); // Close

		$filter.addClass('open');
		$filter.removeClass('closed');
		$filter.find('.filter-options').fadeIn(filterDropdownAnimSpeed);

		// Close panel if any other element is clicked
		$(document).on('click.vibe-job-archive-block', closePanelEventHandler);
	}
}

function closeFilterPanel($filter) {
	if ($filter.length > 0) {
		$filter.addClass('closed');
		$filter.removeClass('open');
		$filter.find('.filter-options').fadeOut(filterDropdownAnimSpeed);

		// Remove event listener that is set up for opening
		$(document).off('click.vibe-job-archive-block', closePanelEventHandler);
	}
}

function closePanelEventHandler(e) {
	let $container = $('.filter-options-wrapper.open');

	// if the target of the click isn't the container nor a descendant of the container
	if (!$container.is(e.target) && $container.has(e.target).length === 0) {
		closeFilterPanel($container);
	}
}

function setupFiltering($block) {
	let $forms = $block.find('.filter-form'),
		$customSelects = $block.find('.filter-options-wrapper');

	$customSelects.each((index, item) => {
		let $customSelect = $(item);

		$customSelect.find('a.filter-option').on('click', function(e) {
			e.preventDefault();

			let filter = $customSelect.data('filter'),
				value = $(this).data('value'),
				$form = $forms.filter(function() {
					return $(this).data('filter') === filter;
				});

			$form.find('select').val(value).trigger('change');
		})
	});

	$forms.each((index, item) => {
		let $form = $(item);

		$form.on('submit', (e) => {
			e.preventDefault();
			updatePage($block);
		});

		$form.find('select').on('change', () => {
			$form.submit();
		});
	});
}

function setupCardFilterLinkClick($block) {
	let $filterLinks = $block.find('a.card-filter-link').not('.setup-click-event');

	$filterLinks.each((index, item) => {
		let $link = $(item);

		$link.on('click', (e) => {
			e.preventDefault();

			let filter = $link.data('filter'),
				value = $link.data('value'),
				$form = $block.find('.filter-form').filter(function() {
					return $(this).data('filter') === filter;
				});

			$form.find('select').val(value).trigger('change');
		});
	});
}

function setupPagination($block) {
	let $pagination = $block.find('.job-archive-pagination'),
		$links = $pagination.find('a.job-archive-page-num');

	$links.each((index, item) => {
		let $pageLink = $(item);

		$pageLink.on('click', (e) => {
			e.preventDefault();

			let pageNum = $pageLink.data('page');

			if (pageNum) {
				updatePage($block, pageNum);
			}
		});
	});
}

function updatePage($block, pageNum = null) {
	$block.addClass('loading');

	let $forms = $block.find('.filter-form');

	let $departmentForm = $forms.filter('[data-filter="department"]'),
		$locationForm = $forms.filter('[data-filter="location-city"]'),
		data = {
			action: 'vibe_teamtailor_integration_territory_studios_jobs_ajax_getJobs',
			nonce: vibeTeamtailorFrontendTerritoryStudioScriptData.vibe_teamtailor_integration_territory_studios_jobs_ajax_getJobs_nonce,
			department: $departmentForm.find('select').val(),
			location: $locationForm.find('select').val(),
			noJobsText: $block.data('no-jobs-text'),
			pageNumber: pageNum
		};

	$.post(vibeTeamtailorFrontendTerritoryStudioScriptData.ajaxURL, data, (response) => {
		updateFiltersHtml($block, response.filtersHtml);
		updateJobCount($block, response.countHtml);
		updateJobsList($block, response.jobsHtml);

		setTimeout(() => {
			let headerOffset = 100;

			$block.removeClass('loading');

			$('body, html').animate({
				scrollTop: $block.offset().top - headerOffset
			});

			updateWindowHistory($block, {
				location: data.location,
				department: data.department,
				pageNumber: pageNum
			});
		}, 200);
	});
}

function updateFiltersHtml($block, html) {
	$block.find('.filters-wrapper').empty().append(html);

	setTimeout(() => {
		setupBlockFilters($block);
		setupFiltering($block);
	}, 100);
}

function updateJobCount($block, html) {
	$block.find('.job-count-col').empty().append(html);
}

function updateJobsList($block, html) {
	$block.find('.jobs-pagination-wrapper').empty().append(html);

	setTimeout(() => {
		setupPagination($block);
		setupCardFilterLinkClick($block);
	}, 100);
}

function updateWindowHistory($block, params = {}) {
	let baseUrl = window.location.href.split('?')[0],
		paramsString = formatURLParameters(params);

	window.history.pushState({jobArchiveHtml: $block.get(0).innerHTML}, '', baseUrl + `?${paramsString}`);
}

function formatURLParameters(params = {}) {
	let query = new URLSearchParams(window.location.search);

	for (const [key, value] of Object.entries(params)) {
		if (value && value !== 'clear') {
			query.set(key, value.toString());
		} else {
			query.delete(key);
		}
	}

	return query.toString();
}

// Will setup the block for the old browser state on forward or back button navigation in browser
function setupPopStateUpdate($block) {
	window.onpopstate = function(e){
		if (e.state && e.state.jobArchiveHtml !== undefined) {
			$block.addClass('loading');

			let $html = $(e.state.jobArchiveHtml);

			// Remove classes that dictate state of elements so that the block is fully reset to starting state
			$html.find('.open').removeClass('open');
			$html.find('.closed').removeClass('closed');
			$html.find('.animating').removeClass('animating');
			$html.find('.filter-options').css('display', 'none');

			$block.empty().append($html);

			setTimeout(() => {
				setupBlock($block);
				$block.removeClass('loading');
			}, 200);
		}
	};
}